module.exports = __webpack_public_path__ + "media/favicon/apple-touch-icon-f8ab9bca.png";